import React from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { WhatsAppButton } from "./WhatsAppButton";
import { PodcastPopup } from "./PodcastPopup";
import { BackToTop } from "./ScrollToTop";
import { UtopistasNotaPopup } from "./UtopistasNotaPopup";
import { useLocation } from "react-router-dom";

export const Layout = ({ children }) => {
  const location = useLocation();
  const isMarca = location.pathname.startsWith("/marca");
  return (
    <div className={isMarca ? "marca-scope" : ""}>
      <Navbar />
      <main>{children}</main>
      <Footer />
      <WhatsAppButton />
      <PodcastPopup />
      <BackToTop />
      <UtopistasNotaPopup />
    </div>
  );
};
